/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supplier_Bank_Identifier_InvalidInputs */

const fr_supplier_bank_identifier_invalid = /** @type {(inputs: Supplier_Bank_Identifier_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un RIB tunisien (20 chiffres), un RIB français (23 caractères) ou un IBAN valide.`)
};

const en_supplier_bank_identifier_invalid = /** @type {(inputs: Supplier_Bank_Identifier_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid Tunisian RIB (20 digits), French RIB (23 characters) or IBAN.`)
};

/**
* | output |
* | --- |
* | "Enter a valid Tunisian RIB (20 digits), French RIB (23 characters) or IBAN." |
*
* @param {Supplier_Bank_Identifier_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const supplier_bank_identifier_invalid = /** @type {((inputs?: Supplier_Bank_Identifier_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supplier_Bank_Identifier_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_supplier_bank_identifier_invalid(inputs)
	return fr_supplier_bank_identifier_invalid(inputs)
});